// Sayfalama: 10/20/30/40 kayıt, 1 2 3 ... sayfa numaraları
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const pages = (cur, last) => {
  const set = new Set([1, last, cur - 1, cur, cur + 1].filter(p => p >= 1 && p <= last));
  const arr = [...set].sort((a, b) => a - b);
  return arr.flatMap((p, i) => (i && p - arr[i - 1] > 1 ? ['…', p] : [p]));
};

export const StorePagination = ({ page, pageSize, total, setPage, setPageSize, unit = 'mağaza', prefix = 'store', sizes = [10, 20, 30, 40] }) => {
  const last = Math.max(1, Math.ceil(total / pageSize));
  const btn = 'h-8 min-w-8 rounded-md px-2 text-sm transition-colors disabled:opacity-40';
  return (
    <div className="flex flex-wrap items-center gap-3 border-t px-4 py-3 text-sm" data-testid={`${prefix}-pagination`}>
      <span className="text-slate-500">{total ? `${(page - 1) * pageSize + 1}-${Math.min(page * pageSize, total)} / ${total} ${unit}` : `0 ${unit}`}</span>
      <div className="mx-auto flex items-center gap-1">
        <button type="button" className={`${btn} hover:bg-slate-100`} disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid={`${prefix}-page-prev`}><ChevronLeft className="h-4 w-4" /></button>
        {pages(page, last).map((p, i) => p === '…' ? <span key={`e${i}`} className="px-1 text-slate-400">…</span> : (
          <button key={p} type="button" onClick={() => setPage(p)} className={`${btn} ${p === page ? 'bg-slate-900 text-white' : 'hover:bg-slate-100'}`} data-testid={`${prefix}-page-${p}`}>{p}</button>
        ))}
        <button type="button" className={`${btn} hover:bg-slate-100`} disabled={page >= last} onClick={() => setPage(page + 1)} data-testid={`${prefix}-page-next`}><ChevronRight className="h-4 w-4" /></button>
      </div>
      <span className="text-slate-500">Sayfa başına</span>
      <Select value={String(pageSize)} onValueChange={(v) => { setPageSize(Number(v)); setPage(1); }}>
        <SelectTrigger className="h-8 w-20" data-testid={`${prefix}-page-size`}><SelectValue /></SelectTrigger>
        <SelectContent>{sizes.map(n => <SelectItem key={n} value={String(n)} data-testid={`${prefix}-page-size-${n}`}>{n}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
};
